import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e38d248"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section__header" }
const _hoisted_2 = { class: "section__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _renderSlot(_ctx.$slots, "paragraph", {}, undefined, true),
    _renderSlot(_ctx.$slots, "action", {}, undefined, true)
  ]))
}